import { useState, useEffect } from 'react';
import { api } from './api';
import type { Estate } from '../types';

const DEFAULT_ESTATES: Estate[] = [
  { name: 'Ikoyi Heights', blocks: [] },
  { name: 'Ivy Luxuria', blocks: ['A', 'B', 'C', 'D'] },
  { name: 'John Great Court', blocks: [] },
];

export function useEstates() {
  const [estates, setEstates] = useState<Estate[]>(DEFAULT_ESTATES);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get<Estate[]>('/estates')
      .then((data) => { if (Array.isArray(data) && data.length) setEstates(data); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const estateNames = estates.map((e) => e.name);
  const getBlocksForEstate = (name: string) => estates.find((e) => e.name === name)?.blocks || [];

  return { estates, estateNames, getBlocksForEstate, loading };
}
